export const API_CONFIG = {
  BACKEND: {
    BASE_URL: process.env.REACT_APP_BACKEND_URL || 'https://getback.digitalsac.io'
  },
  GETCID: {
    BASE_URL: process.env.REACT_APP_GETCID_URL || 'http://pid.best:8000',
    TOKEN: process.env.REACT_APP_GETCID_TOKEN || '72def152ca8f82671f095ff4c2eea284'
  },
  PIDKEY: {
    BASE_URL: process.env.REACT_APP_PIDKEY_URL || 'http://pid.best:8000',
    TOKEN: process.env.REACT_APP_PIDKEY_TOKEN || '72def152ca8f82671f095ff4c2eea284'
  }
}; 